import './FileUploadingInfo.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as DocIcon } from '../../../resources/icons/doc.svg';
import { ReactComponent as DeleteIcon } from '../../../resources/icons/delete.svg';
import { ReactComponent as SuccessIcon } from '../../../resources/icons/success-icon.svg';
import { ReactComponent as ErrorIcon } from '../../../resources/icons/error.svg';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
const FileUploadingInfo = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info"
  }, props.formName && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "file-uploading-info__form-name",
    field: {
      value: props.formName
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__card"
  }, /*#__PURE__*/React.createElement(DocIcon, {
    className: "file-uploading-info__doc-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__file-info-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__name-size-delete"
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__name-size"
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__name"
  }, props.filename), !!props.size && /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__size"
  }, props.size < 1024 ? props.byteDict.replace('$value$', props.size.toFixed(0)) : props.kbDict.replace('$value$', (props.size / 1024).toFixed(1)))), props.onDelete && /*#__PURE__*/React.createElement("button", {
    onClick: props.onDelete,
    className: `file-uploading-info__delete-button ${props.isLoading ? 'file-uploading-info__delete-button--hidden' : ''}`
  }, /*#__PURE__*/React.createElement(DeleteIcon, {
    className: "file-uploading-info__delete-icon"
  }))), props.isLoading && !props.error && /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__progress-wrapper"
  }, /*#__PURE__*/React.createElement("progress", {
    value: props.percent,
    max: 100,
    className: "file-uploading-info__progress"
  }, props.percent, "%"), /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__percent"
  }, props.percent, "%")), props.isUploaded && !props.error && /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__message"
  }, /*#__PURE__*/React.createElement(SuccessIcon, {
    className: "file-uploading-info__success-icon"
  }), /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: props.successMessage
    }
  })), props.error && /*#__PURE__*/React.createElement("div", {
    className: "file-uploading-info__message file-uploading-info__error-message"
  }, /*#__PURE__*/React.createElement(ErrorIcon, {
    className: "file-uploading-info__error-icon"
  }), /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: props.error
    }
  }))))));
};
export default FileUploadingInfo;
const StyledWrapper = _ref => {
  let {
    children,
    rtl
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "cleiuc2";
const rtlStyles = "r16i8xfk";
const ltrStyles = "l16ndkqt";